// extracted by css-extract-rspack-plugin
export default {"card":"card-n8Qs3w","divider":"divider-oaO0a7"};